const DiscountIcon = (props) => (

        <svg fill="#000000" width="24px" height="24px" viewBox="0 0 16 16" >
            <path
                d="M10.09 4.37a.62.62 0 0 0-.85.23l-3.57 6.18a.62.62 0 0 0 .23.85.55.55 0 0 0 .31.08.63.63 0 0 0 .54-.31l3.57-6.18a.61.61 0 0 0-.23-.85zM7.35 6.43a2.16 2.16 0 0 0-2.06-2.24 2.17 2.17 0 0 0-2.07 2.24 2.17 2.17 0 0 0 2.07 2.25 2.16 2.16 0 0 0 2.06-2.25zm-2.06 1a.93.93 0 0 1-.82-1 .92.92 0 0 1 .82-1 .91.91 0 0 1 .81 1 .92.92 0 0 1-.81 1zm5.42-.11a2.16 2.16 0 0 0-2.06 2.24 2.16 2.16 0 0 0 2.06 2.25 2.17 2.17 0 0 0 2.07-2.25 2.17 2.17 0 0 0-2.07-2.24zm0 3.24a.92.92 0 0 1-.81-1 .92.92 0 0 1 .81-1 .92.92 0 0 1 .82 1 .93.93 0 0 1-.82 1z"/>
            <path
                d="M8 .5A7.76 7.76 0 0 0 0 8a7.76 7.76 0 0 0 8 7.5A7.76 7.76 0 0 0 16 8 7.76 7.76 0 0 0 8 .5zm0 13.75A6.52 6.52 0 0 1 1.25 8 6.52 6.52 0 0 1 8 1.75 6.52 6.52 0 0 1 14.75 8 6.52 6.52 0 0 1 8 14.25z"/>
        </svg>


    )
;

export default DiscountIcon;
